/* tslint:disabled */
/* eslint-disable */
/**
 * Alerts
 * The service provides RESTful API for manipulating alerts (CRUD)
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ResponseBody } from 'redux-query'
import {
  Alert,
  AlertCreatePayload,
  AlertCreatePayloadToJSON,
  AlertFromJSON,
  AlertShowParameterEnum,
  DismissAlertPayload,
  DismissAlertPayloadToJSON,
  ReferenceTypeEnum,
  Summary,
  SummaryFromJSON,
  SummaryTypeEnum
} from '../models'
import * as runtime from '../runtime'

export interface CreateAlertRequest {
  alertCreatePayload?: AlertCreatePayload
}

export interface DeleteAlertRequest {
  id: string
}

export interface DismissAlertRequest {
  id: string
  dismissAlertPayload?: DismissAlertPayload
}

export interface GetAlertsRequest {
  referenceId: string
  referenceType: ReferenceTypeEnum
  show?: AlertShowParameterEnum
  failed?: boolean
}

export interface GetAlertsSummaryRequest {
  type: SummaryTypeEnum
  accountIds?: Array<string>
  objectURI?: string
}

/**
 * Creates a new alert
 * Create a new alert
 */
function createAlertQueryConfigRaw<T>(
  requestParameters: CreateAlertRequest,
  requestConfig: runtime.TypedQueryConfig<T, Alert> = {}
): runtime.RequestConfig<T> {
  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  headerParameters['Content-Type'] = 'application/json'

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/alerts`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'POST',
      headers: headerParameters
    },
    body:
      queryParameters ||
      AlertCreatePayloadToJSON(requestParameters.alertCreatePayload)
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(AlertFromJSON(body), text)
  }

  return config
}

/**
 * Creates a new alert
 * Create a new alert
 */
export function createAlertQueryConfig<T>(
  requestParameters: CreateAlertRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Alert>
): runtime.RequestConfig<T> {
  return createAlertQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Deletes alert
 * Delete alert
 */
function deleteAlertQueryConfigRaw<T>(
  requestParameters: DeleteAlertRequest,
  requestConfig: runtime.TypedQueryConfig<T, void> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.id === null || requestParameters.id === undefined) {
    throw new runtime.RequiredError(
      'id',
      'Required parameter requestParameters.id was null or undefined when calling deleteAlertQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/alerts/{id}`.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters.id))
    ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'DELETE',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
  }

  return config
}

/**
 * Deletes alert
 * Delete alert
 */
export function deleteAlertQueryConfig<T>(
  requestParameters: DeleteAlertRequest,
  requestConfig?: runtime.TypedQueryConfig<T, void>
): runtime.RequestConfig<T> {
  return deleteAlertQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Updates dismiss status of an alert
 * Dismiss alert
 */
function dismissAlertQueryConfigRaw<T>(
  requestParameters: DismissAlertRequest,
  requestConfig: runtime.TypedQueryConfig<T, void> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.id === null || requestParameters.id === undefined) {
    throw new runtime.RequiredError(
      'id',
      'Required parameter requestParameters.id was null or undefined when calling dismissAlertQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  headerParameters['Content-Type'] = 'application/json'

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/alerts/{id}/dismiss`.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters.id))
    ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'POST',
      headers: headerParameters
    },
    body:
      queryParameters ||
      DismissAlertPayloadToJSON(requestParameters.dismissAlertPayload)
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
  }

  return config
}

/**
 * Updates dismiss status of an alert
 * Dismiss alert
 */
export function dismissAlertQueryConfig<T>(
  requestParameters: DismissAlertRequest,
  requestConfig?: runtime.TypedQueryConfig<T, void>
): runtime.RequestConfig<T> {
  return dismissAlertQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Returns list of alerts
 * Retrieve list of alerts
 */
function getAlertsQueryConfigRaw<T>(
  requestParameters: GetAlertsRequest,
  requestConfig: runtime.TypedQueryConfig<T, Array<Alert>> = {}
): runtime.RequestConfig<T> {
  if (
    requestParameters.referenceId === null ||
    requestParameters.referenceId === undefined
  ) {
    throw new runtime.RequiredError(
      'referenceId',
      'Required parameter requestParameters.referenceId was null or undefined when calling getAlertsQueryConfig.'
    )
  }

  if (
    requestParameters.referenceType === null ||
    requestParameters.referenceType === undefined
  ) {
    throw new runtime.RequiredError(
      'referenceType',
      'Required parameter requestParameters.referenceType was null or undefined when calling getAlertsQueryConfig.'
    )
  }

  let queryParameters = null

  queryParameters = {}

  if (requestParameters.referenceId !== undefined) {
    queryParameters['referenceId'] = requestParameters.referenceId
  }

  if (requestParameters.referenceType !== undefined) {
    queryParameters['referenceType'] = requestParameters.referenceType
  }

  if (requestParameters.show !== undefined) {
    queryParameters['show'] = requestParameters.show
  }

  if (requestParameters.failed !== undefined) {
    queryParameters['failed'] = requestParameters.failed
  }

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/alerts`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'GET',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(body.map(AlertFromJSON), text)
  }

  return config
}

/**
 * Returns list of alerts
 * Retrieve list of alerts
 */
export function getAlertsQueryConfig<T>(
  requestParameters: GetAlertsRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Array<Alert>>
): runtime.RequestConfig<T> {
  return getAlertsQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Returns alert counts per severity or per refference
 * Retrieve alert counts per severity or per refference
 */
function getAlertsSummaryQueryConfigRaw<T>(
  requestParameters: GetAlertsSummaryRequest,
  requestConfig: runtime.TypedQueryConfig<T, Array<Summary>> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.type === null || requestParameters.type === undefined) {
    throw new runtime.RequiredError(
      'type',
      'Required parameter requestParameters.type was null or undefined when calling getAlertsSummaryQueryConfig.'
    )
  }

  let queryParameters = null

  queryParameters = {}

  if (requestParameters.type !== undefined) {
    queryParameters['type'] = requestParameters.type
  }

  if (requestParameters.accountIds) {
    queryParameters['accountIds'] = requestParameters.accountIds?.join(
      runtime.COLLECTION_FORMATS['csv']
    )
  }

  if (requestParameters.objectURI !== undefined) {
    queryParameters['objectURI'] = requestParameters.objectURI
  }

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/alerts/summary`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'GET',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(body.map(SummaryFromJSON), text)
  }

  return config
}

/**
 * Returns alert counts per severity or per refference
 * Retrieve alert counts per severity or per refference
 */
export function getAlertsSummaryQueryConfig<T>(
  requestParameters: GetAlertsSummaryRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Array<Summary>>
): runtime.RequestConfig<T> {
  return getAlertsSummaryQueryConfigRaw(requestParameters, requestConfig)
}

//Requests

/**
 * Creates a new alert
 * Create a new alert
 */

async function createAlertRequestRaw(
  requestParameters: CreateAlertRequest
): Promise<runtime.APIResponse<Alert>> {
  const { url, options, body } = createAlertQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    AlertFromJSON(jsonValue)
  )
}

/**
 * Creates a new alert
 * Create a new alert
 */
export async function createAlert(
  requestParameters: CreateAlertRequest
): Promise<runtime.APIResponse<Alert>> {
  return await createAlertRequestRaw(requestParameters)
}

/**
 * Deletes alert
 * Delete alert
 */

async function deleteAlertRequestRaw(
  requestParameters: DeleteAlertRequest
): Promise<runtime.APIResponse<void>> {
  const { url, options, body } = deleteAlertQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.VoidApiResponse(response)
}

/**
 * Deletes alert
 * Delete alert
 */
export async function deleteAlert(
  requestParameters: DeleteAlertRequest
): Promise<runtime.APIResponse<void>> {
  return await deleteAlertRequestRaw(requestParameters)
}

/**
 * Updates dismiss status of an alert
 * Dismiss alert
 */

async function dismissAlertRequestRaw(
  requestParameters: DismissAlertRequest
): Promise<runtime.APIResponse<void>> {
  const { url, options, body } = dismissAlertQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.VoidApiResponse(response)
}

/**
 * Updates dismiss status of an alert
 * Dismiss alert
 */
export async function dismissAlert(
  requestParameters: DismissAlertRequest
): Promise<runtime.APIResponse<void>> {
  return await dismissAlertRequestRaw(requestParameters)
}

/**
 * Returns list of alerts
 * Retrieve list of alerts
 */

async function getAlertsRequestRaw(
  requestParameters: GetAlertsRequest
): Promise<runtime.APIResponse<Array<Alert>>> {
  const { url, options, body } = getAlertsQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    jsonValue.map(AlertFromJSON)
  )
}

/**
 * Returns list of alerts
 * Retrieve list of alerts
 */
export async function getAlerts(
  requestParameters: GetAlertsRequest
): Promise<runtime.APIResponse<Array<Alert>>> {
  return await getAlertsRequestRaw(requestParameters)
}

/**
 * Returns alert counts per severity or per refference
 * Retrieve alert counts per severity or per refference
 */

async function getAlertsSummaryRequestRaw(
  requestParameters: GetAlertsSummaryRequest
): Promise<runtime.APIResponse<Array<Summary>>> {
  const { url, options, body } =
    getAlertsSummaryQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    jsonValue.map(SummaryFromJSON)
  )
}

/**
 * Returns alert counts per severity or per refference
 * Retrieve alert counts per severity or per refference
 */
export async function getAlertsSummary(
  requestParameters: GetAlertsSummaryRequest
): Promise<runtime.APIResponse<Array<Summary>>> {
  return await getAlertsSummaryRequestRaw(requestParameters)
}
